import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import './index.scss';
import { Col, Row } from 'react-bootstrap';
import RightSidebar from 'components/Layout/RightSidebar';
import ControlPanel from 'components/Meteorology/Fields/ControlPanel';
import TabbedPage from 'components/TabbedPage';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import useIsMobile from 'utils/hooks/useIsMobile';
import shortenedTabPath from 'helper/shortenedTabPath';
import { openRight } from 'redux/reducers/sidebarsReducer';
import {
  setErrorAlert,
  setObsImageString,
  setClimatologyImageString,
  setAnomalyImageString,
} from 'redux/reducers/meteorologyFieldsObservedDataControlPanelReducer';

const SIDEBAR_PATHS = [
  '/meteorology/fields/trackingforecast/detailedview',
  '/meteorology/fields/observeddata',
  '/meteorology/fields/numericforecast',
  '/meteorology/fields/comparator',
  '/meteorology/fields/classiccomparator',
  '/meteorology/fields/modelperformance',
];

const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Acompanhamento/Previsão', path: '/meteorology/fields/trackingforecast/' },
  { title: 'Dados Observados', path: '/meteorology/fields/observeddata' },
  { title: 'Previsão Numérica', path: '/meteorology/fields/numericforecast' },
  { title: 'Comparador', path: '/meteorology/fields/comparator' },
  { title: 'Comparador Clássico', path: '/meteorology/fields/classiccomparator' },
  { title: 'Campos Sinóticos', path: '/meteorology/fields/synopticcharts' },
  { title: 'Desempenho', path: '/meteorology/fields/modelperformance/' },
];

export default function MeteorologyFieldsLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [moreOpen, setMoreOpen] = useState(false);
  const showSidebar = SIDEBAR_PATHS.some((path) => location.pathname.includes(path));

  useEffect(() => {
    dispatch(openRight());
    return () => {
      dispatch(setObsImageString(''));
      dispatch(setClimatologyImageString(''));
      dispatch(setAnomalyImageString(''));
      dispatch(setErrorAlert(undefined));
    };
  }, [dispatch]);

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <>
        <MobileSectionHeader
          backLabel="Mapas e meteogramas"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/meteorology')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Row>
        <Col className="md-6">
          <h1 className=" mb-3">Mapas e meteogramas</h1>
        </Col>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col xs="auto" className="flex-fill overflow-hidden">
          <TabbedPage>
            <TabbedPage.Tab title="ACOMPANHAMENTO/PREVISÃO" path="/meteorology/fields/trackingforecast/" />
            <TabbedPage.Tab title="DADOS OBSERVADOS" path="/meteorology/fields/observeddata" />
            <TabbedPage.Tab title="PREVISÃO NUMÉRICA DO TEMPO" path="/meteorology/fields/numericforecast" />
            <TabbedPage.Tab title="COMPARADOR" path="/meteorology/fields/comparator" />
            <TabbedPage.Tab title="COMPARADOR CLÁSSICO" path="/meteorology/fields/classiccomparator" />
            <TabbedPage.Tab title="CAMPOS SINÓTICOS" path="/meteorology/fields/synopticcharts" />
            <TabbedPage.Tab title="DESEMPENHO DE MODELOS" path="/meteorology/fields/modelperformance/" />
          </TabbedPage>
        </Col>
        {showSidebar && (
          <Col xs="auto">
            <RightSidebar>
              <ControlPanel />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </>
  );
}
